import { createSelector } from 'reselect';

const selectPolicyDomain = (state) => state.policy;

export const selectPolicyTerms = () =>
    createSelector(selectPolicyDomain, (substate) => {
        return substate.policyTerms;
    });
